import React from 'react';
import P from 'components/P';
import UL from 'components/UL';
import LI from 'components/LI';
import A from 'components/A';

function TeamsActionContent () {
  return (
    <>
      <P>There are 2 ways to send a message to Microsoft Teams:</P>
      <UL>
        <LI>
          <A href="https://airmanual.link/help/send-email-to-teams" target="_blank">
                Send an email to a Teams channel
          </A>{' '}
              (easiest)
        </LI>
        <LI>
          <A href="https://airmanual.link/help/send-customized-message-to-teams" target="_blank">
                Send a customized message to Teams via Zapier
          </A>
        </LI>
      </UL>
      <A href="https://www.airmanual.co/support" target="_blank">
            Contact support
      </A>{' '}
          if you need any help.
    </>
  );
}

export default TeamsActionContent;
